// Destaque visual de campos/itens pendentes após uma tentativa de avançar:
// rola até o item, foca o primeiro elemento interativo e aplica a tremida
// (classe global `campo-shake`, definida em index.css).
//
// Cada item destacável precisa de um wrapper com `data-field-name="<id>"`.

const localizar = (id) => {
  const seletor = window.CSS?.escape ? window.CSS.escape(id) : id;
  return document.querySelector(`[data-field-name="${seletor}"]`);
};

export const focarCampo = (id) => {
  const wrapper = localizar(id);
  if (!wrapper) return;

  wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
  const focavel = wrapper.querySelector('input:not([disabled]):not([type="file"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])');
  focavel?.focus({ preventScroll: true });
};

// Reaplica a animação mesmo se a classe já estiver no elemento (tentativas seguidas).
const tremerCampo = (id) => {
  const wrapper = localizar(id);
  if (!wrapper) return;

  wrapper.classList.remove('campo-shake');
  void wrapper.offsetWidth;
  wrapper.classList.add('campo-shake');
  wrapper.addEventListener('animationend', () => wrapper.classList.remove('campo-shake'), { once: true });
};

// Espera o React pintar o estado de erro antes de rolar/tremer.
export const destacarPendencias = (ids) => {
  if (!ids?.length) return;
  requestAnimationFrame(() => {
    ids.forEach(tremerCampo);
    focarCampo(ids[0]);
  });
};
